import { OverviewItems } from 'components/cases/common/Overview/Overview'
import { IssueSolutionItems } from 'components/cases/common/Overview/Overview'
import { CaseStudyItems } from 'components/cases/common/CaseStudy/CaseStudy'

// ファーストビュー
export const firstViewItem = {
  breadcrumb: '東京スター銀行アプリ',
  title1: '東京スター銀行アプリ',
  introduction_text:
    '銀行口座アプリのUIデザインを担当しました。デザイン思考のアプローチで元々あった機能一覧を再考し、モック制作、ユーザー調査からコンセプトを再設計して、UIデザインまで実施しました。',
  company: '株式会社野村総合研究所',
  tag1text: 'UI/UXデザイン',
  tag1src: '/cases/uiuxdesign',
  industryTagText: '銀行/保険/証券',
  industryTagSrc: '/cases/finance',
  color: '',
  background: '#FFC785',
  staff1: '',
  image: '/images/img/cases/caseStudyTop/nri.webp',
  alt: '東京スター銀行アプリ',
  imgClass: 'fv_img_adjust1',
}

// プロジェクト概要
export const overviewTitle = '顧客接点を最適化するUIデザインのご支援'
export const overviewItem: OverviewItems[] = [
  {
    text: '機能一覧でみると差別化が難しい銀行口座アプリ。その一方で口座アプリは銀行が顧客ダイレクトに接点を持つことができる重要なデジタルサービスです。当社では、元々あった機能一覧を再考し、デザイン思考のアプローチでユーザーが使うアプリは何かを検討して、モック制作、ユーザー調査からコンセプトを再設計して、UIデザインを担当させていただきました。',
  },
]

// 課題と解決策
export const issueSolutionItems: IssueSolutionItems[] = [
  {
    issues: [
      {
        title: 'ペルソナに適したUI/UXの作り方がわからない',
        text: '',
      },
      {
        title: '継続的に接点を持ってもらうための知見がない',
        text: '',
      },
      {
        title: '複数の施策案があるものの、施策の優先順位をつけにくい',
        text: '',
      },
    ],
    solutions: [
      {
        title: 'デザイン思考でユーザー調査からコンセプトの再設計',
        text: '',
      },
      {
        title: 'モックを作成し、UIデザインの検証実施',
        text: '',
      },
      {
        title: '各種フレームワークも活用し、優先順位付け',
        text: '',
      },
    ],
  },
]

// 関連事例
export const caseStudyItem: CaseStudyItems = [
  {
    projectName: '【技術系災害ボランティア体験】家屋再生〜水害編〜',
    client: '公益財団法人日本財団ボランティアセンター様',
    src: '/images/img/case/img_case_volunteer-ex.png',
    alt: '公益財団法人日本財団ボランティアセンター様',
    href: '#',
    tags: [{ name: 'XR/メタバース導入', url: 'xr' }],
  },
  {
    projectName: 'PEACH JOHN',
    client: '株式会社ピーチ・ジョン様',
    src: '/images/img/case/img_peachjohn.png',
    alt: '株式会社ピーチ・ジョン様',
    href: '#',
    tags: [
      { name: 'UI/UXデザイン', url: 'uiux' },
      { name: 'アプリケーション開発', url: 'application-development' },
      { name: '小売', url: 'service' },
    ],
  },
  {
    projectName: 'セブンネットショッピング「推し活倶楽部」',
    client: '株式会社セブンネットショッピング様',
    src: '/images/img/case/img_sevennet.png',
    alt: '株式会社セブンネットショッピング様',
    href: '#',
    tags: [
      { name: 'UI/UXデザイン', url: 'uiux' },
      { name: 'アーキテクチャ設計サービス', url: 'architecture-design' },
      { name: '小売', url: 'service' },
    ],
  },
]
